const BLOCKED_LIFECYCLES = ['frozen', 'draining', 'closed', 'failed']

export const isStripeAccountReady = account =>
  Boolean(account?.exists && !account.needs_onboarding && account.lifecycle === 'active')

export default {
  onboardingRequired(state) {
    return Boolean(state.accountAvailable && state.account && (!state.account.exists || state.account.needs_onboarding))
  },

  accountReady(state) {
    return Boolean(state.accountAvailable && isStripeAccountReady(state.account))
  },

  dashboardAvailable(state) {
    return Boolean(state.accountAvailable && state.account?.dashboard_available)
  },

  activeFundingMethod(state) {
    return state.fundingMethod?.status === 'active' && state.fundingMethod?.is_default ? state.fundingMethod : null
  },

  accountViewState(state, getters) {
    if (state.accountLoading && !state.accountLoaded) return 'loading'
    if (state.accountError) return 'error'
    if (!state.accountLoaded || !state.accountAvailable) return 'unavailable'
    if (!state.account?.exists) return 'new'
    if (BLOCKED_LIFECYCLES.includes(state.account.lifecycle)) return 'blocked'
    if (state.account.lifecycle === 'restricted') return 'restricted'
    if (state.account.needs_onboarding) return 'incomplete'
    if (state.account.lifecycle === 'onboarding' || state.account.lifecycle === 'creating') return 'review'
    if (getters.accountReady) return 'active'
    return 'restricted'
  },

  bankViewState(state) {
    if (state.achError) return 'error'
    if (!state.achLoading && !state.achAvailable) return 'unavailable'
    if (!state.fundingMethod) return 'new'
    if (state.fundingMethod.mandate_action_required || state.fundingMethod.status === 'revoked') return 'reauthorize'
    if (state.fundingMethod.status === 'active' && state.fundingMethod.is_default) return 'active'
    if (state.fundingMethod.status === 'pending') {
      return ['succeeded', 'processing'].includes(state.fundingMethod.stripe_status) ? 'syncing' : 'pending'
    }
    if (['blocked', 'failed', 'canceled', 'superseded'].includes(state.fundingMethod.status)) return 'reauthorize'
    return 'syncing'
  },

  stripeStatus(_, getters) {
    const statuses = {
      loading: { label: 'Loading', tone: 'info' },
      error: { label: 'Unavailable', tone: 'error' },
      unavailable: { label: 'Unavailable', tone: 'neutral' },
      new: { label: 'Not connected', tone: 'neutral' },
      incomplete: { label: 'Setup incomplete', tone: 'warning' },
      review: { label: 'Under review', tone: 'info' },
      restricted: { label: 'Action required', tone: 'warning' },
      blocked: { label: 'Restricted', tone: 'error' },
      active: { label: 'Active', tone: 'success' }
    }
    return statuses[getters.accountViewState]
  }
}
